import {Component, HostListener, OnDestroy, OnInit, ViewChild, inject} from '@angular/core';
import {AutoUnsubscribe} from '../../../decorators/auto-unsubscribe.decorator';
import {MatDrawer, MatSidenavModule} from '@angular/material/sidenav';
import {MediaMatcher} from '@angular/cdk/layout';
import {NotificationsDrawerService} from 'src/app/modules/notifications-drawer/notifications-drawer.service';
import {debounceTime, distinctUntilChanged, filter} from 'rxjs/operators';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {SUBSCRIPTIONS} from '../../../common/utils/constants';
import {PageTitleService} from '../../../services/page-title.service';
import {ConfirmDialogService} from 'src/app/services/confirm-dialog.service';
import {EventEmitterService} from 'src/app/services/event-emitter.service';
import {SubscriptionService} from '../../../services/subscriptions.service';
import {UserPermissions} from '../../../common/elf-store/user-permissions/user-permissions.store';
import {FeatureFlagModalComponent} from '../feature-flag-modal/feature-flag-modal.component';
import {MatDialog} from '@angular/material/dialog';
import {HeaderComponent} from './header/header.component';
import {PermissionGuardDirective} from '../../../common/directives/permission-guard.directive';
import {NotificationsDrawerComponent} from '../../../modules/notifications-drawer/notifications-drawer.component';
import {NgClass, AsyncPipe} from '@angular/common';
import {NavigationComponent} from './navigation/navigation.component';
import {MatIconModule} from '@angular/material/icon';

@Component({
  standalone: true,
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  imports: [
    HeaderComponent,
    PermissionGuardDirective,
    NotificationsDrawerComponent,
    NgClass,
    NavigationComponent,
    RouterOutlet,
    AsyncPipe,
    MatIconModule,
    MatSidenavModule,
  ],
})
@AutoUnsubscribe()
export class MainLayoutComponent implements OnInit, OnDestroy {
  private pageTitleService = inject(PageTitleService);
  private media = inject(MediaMatcher);
  private confirmDialogService = inject(ConfirmDialogService);
  private eventEmitterService = inject(EventEmitterService);
  router = inject(Router);
  subscriptionService = inject(SubscriptionService);
  dialog = inject(MatDialog);
  notificationsDrawer = inject(NotificationsDrawerService);

  // [NEW-GROUP] - temporary disabled for ticket DASH-1168
  // private keysPressed = new Set<string>();
  // @HostListener('window:keydown', ['$event'])
  // handleKeyDown(event: KeyboardEvent) {
  //   this.keysPressed.add(event.key);
  //   if (this.keysPressed.has('Control') && this.keysPressed.has('Shift') && this.keysPressed.has('F')) {
  //     event.preventDefault();
  //     this.openFeatureFlagModal();
  //     this.keysPressed.clear();
  //   }
  // }
  //
  // @HostListener('window:keyup', ['$event'])
  // handleKeyUp() {
  //   this.keysPressed.clear();
  // }

  @ViewChild('sidenav') sidenav: MatDrawer;
  mobileQuery: MediaQueryList;
  sideNavOpened: boolean = true;
  hoverBlocked: boolean;
  private mobileQueryListener: () => void;
  constructor() {
    const media = this.media;

    this.mobileQuery = media.matchMedia('(max-width: 1300px)');
    this.mobileQueryListener = () => (this.sideNavOpened = !this.mobileQuery.matches);
    this.mobileQuery.addEventListener('change', this.mobileQueryListener);
  }

  get UserPermissions() {
    return UserPermissions;
  }

  get isRegulationLawsView() {
    return this.router.url === '/regulation/laws';
  }

  ngOnInit() {
    this[SUBSCRIPTIONS].add(
      this.eventEmitterService.showForbiddenDialog.pipe(debounceTime(300), distinctUntilChanged()).subscribe(value => {
        if (value) {
          const dialogSub = this.confirmDialogService
            .showForbiddenDialog()
            .afterClosed()
            .pipe(debounceTime(1000))
            .subscribe(() => {
              this.eventEmitterService.showForbiddenDialog.next(null);
              dialogSub.unsubscribe();
            });
        }
      }),
    );
    this.sideNavOpened = !this.mobileQuery.matches;
    this.subscriptionService.getAccountManager().subscribe();
    this.pageTitleService.setPageTitle(this.router.url);
    this[SUBSCRIPTIONS].add(
      this.router.events
        .pipe(filter((event: NavigationEnd) => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.pageTitleService.setPageTitle(event.url);
        }),
    );
  }

  ngOnDestroy() {
    this.mobileQuery.removeEventListener('change', this.mobileQueryListener);
  }

  @HostListener('document:keydown', ['$event'])
  handleKeydown(event: KeyboardEvent): void {
    if (event.key === '[') {
      this.sidenav.open();
      this.hoverBlocked = false;
    } else if (event.key === ']') {
      this.sidenav.close();
      this.hoverBlocked = true;
    }
  }

  onToggleClick(): void {
    this.sidenav.opened = !this.sidenav.opened;
    this.hoverBlocked = !this.hoverBlocked;
  }

  openFeatureFlagModal() {
    this.dialog.open(FeatureFlagModalComponent);
  }
}
